<template>
  <layout-component
    headerTitle="SOLICITUDES - GESTIÓN DE TIQUETES"
    headerSubTitle="Información especifica del permiso con tiquetes"
    :showLocation="false"
  >
    <template #container>
      <div style="display: flex; left: 15px; margin-bottom: 10px">
        <label class="mr-2 breadcrumb-link"
          ><button
            class="mt-0 p-0 pb-1 d-flex align-items-center breadcrumb-link back"
            style="
              border: none;
              background-color: transparent;
              font-size: 16px;
            "
            @click.prevent="backGes"
          >
            Volver
          </button></label
        >
      </div>
      <b-card>
        <b-card-text>
          <template v-if="processing">
            <p class="center pt-3">Cargando...</p>
          </template>
          <template v-else>
            <b-row class="p-4 pt-5 pb-5">
              <b-col cols="12" class="title">
                Solicitud permiso con tiquetes - ID {{ currentId }}
              </b-col>
              <b-col cols="12" class="pt-4">
                <table-single-component
                  :fields="fieldsRequest"
                  :items="license"
                />
              </b-col>
              <b-col cols="12" class="pt-4">
                <toaster-informative-component
                  show
                  hide-circle-to-icon
                  :message="messageToasterInformative"
                />
              </b-col>
              <b-col cols="12" class="title pt-4 pb-2">
                Datos de las personas para solicitar tiquetes
              </b-col>
              <b-col cols="auto" class="mt-3 mb-3">
                <button class="button-primary" @click.prevent="redirectToManagement()">
                  <span
                    >Gestionar tiquetes</span>
                </button>
              </b-col>
              <b-col cols="12" class="pt-4">
                <table-collaborators-component
                  :fields="fieldRequestCollaborators"
                  :items="itemsRequestCollaborators"
                  @click:collaborator="redirectToManagement"
                />
              </b-col>
            </b-row>
          </template>
        </b-card-text>
      </b-card>
    </template>
  </layout-component>
</template>
<script>
import { getLicense } from "@/services/modules/permisos-sindicales/v2/licenses/gestor-impuestos/service";

export default {
  name: "show",
  components: {
    layoutComponent: () =>
      import("@/layouts/modules/permisos-sindicales/v2/app.vue"),
    toasterInformativeComponent: () =>
      import("@/components/common/toasters/Informative.vue"),
    tableComponent: () =>
      import("@/components/Modules/PermisosSindicales/Common/Table/Table.vue"),
    tableSingleComponent: () =>
      import(
        "@/components/Modules/PermisosSindicales/Requests/GestorImpuestos/Table/Show/Single/SingleTable.vue"
      ),
    tableCollaboratorsComponent: () =>
      import(
        "@/components/Modules/PermisosSindicales/Requests/GestorImpuestos/Table/Show/Collaborators/CollaboratorsTable.vue"
      ),
  },
  data: () => ({
    processing: true,
    license: [],
  }),
  computed: {
    // ## IDE QUE VIENE EN LA RUTA
    currentId() {
      return Number(this.$route.params.id || 0);
    },
    // ## MENSAJE QUE SE MUESTRA EN LA ALERTA INFORMATIVA
    messageToasterInformative() {
      return "Recuerda que el estado  en Gestión de tiquetes cambiará de sin gestionar  a gestionado debes gestionar los tiquetes de todos los colaboradores";
    },
    // ## CAMPOS DE LA TABLA DEL PERMISO
    fieldsRequest() {
      return [
        {
          label: "ID Solicitud",
          key: "id",
        },
        {
          label: "Sindicato",
          key: "labor_union",
        },
        {
          label: "Solicitante",
          key: "petitioner",
        },
        {
          label: "Fecha solicitud",
          key: "created",
        },
        {
          label: "Fecha aprobación",
          key: "approval_date",
        },
        {
          label: "Tiquetes solicitados",
          key: "count_all_tickets",
        },
        {
          label: "Tiquetes aprobados",
          key: "count_tickets",
        },
        {
          label: "Destino",
          key: "destination",
        },
        {
          label: "Estado gestión compra de tiquetes",
          key: "state_ticket",
        },
      ];
    },
    // ## CAMPOS PARA LA TABLA DE COLABORADORES
    fieldRequestCollaborators() {
      return [
        {
          label: "Nombre completo",
          key: "name",
        },
        {
          label: "Sharp ID",
          key: "sharp_id",
        },
        {
          label: "Cédula",
          key: "cc",
        },
        {
          label: "Aprobación",
          key: "approver",
        },
        {
          label: "Salida",
          key: "origin",
        },
        {
          label: "Destino",
          key: "destination",
        },
        {
          label: "Fecha inicio",
          key: "start_date",
        },
        {
          label: "Fecha fin",
          key: "end_date",
        },
        {
          label: "",
          key: "gestion",
        },
      ];
    },
    // ## ITEMS DE LOS COLABORADOERES DEL PEMISO
    itemsRequestCollaborators() {
      return this.license.length ? this.license[0].tickets : [];
    },
  },
  mounted() {
    // ## CARGA LA LICENCIA
    getLicense(this.currentId)
      .then(({ result }) => {
        this.license.push(result);
      })
      .finally(() => (this.processing = false));
  },
  methods: {
    redirectToManagement() {
      this.$router.push({
        name: "request-of-gestor-impuestos-management",
        params: { id: this.currentId },
      });
    },
    backGes() {
      this.$router.push("/requests-gestor-impuestos");
    }
  },
};
</script>

<style lang="scss">
.card-body {
  padding: 0;
}
.card {
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.15) !important;
  border-radius: 2px !important;
}
.title {
  font-family: Ubuntu, serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0;
  text-align: left;
  color: rgba(28, 58, 78, 1);
}

//## CENTRA TODO EL CONTENIDO
.center {
  display: grid;
  place-items: center;
}
</style>
